export const reviewKeys = {
  all: ["review"] as const,
  ticketByBoard: (boardCode: string) => [...reviewKeys.all, "ticket-by-board", boardCode] as const,
  flow: (flowId: string) => [...reviewKeys.all, "flow", flowId] as const,
};
